import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
} from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DeleteIcon from '@material-ui/icons/Delete'

import './SostenibilidadEnergiaContainer.css'

import {
  getEnergias,
  getEnsambladoras,
  postEnergia,
  deleteEnergia,
  getTipos,
  getPermisosByUser,
} from '@auteco/services/sostenibilidadService'

const SostenibilidadEnergiaContainer = () => {
  const [data, setData] = useState([])
  const [empresasList, setEmpresasList] = useState([])

  const [tipos, setTipos] = useState('')
  const [fechaInicial, setFechaInicial] = useState(null)
  const [fechaFinal, setFechaFinal] = useState(null)
  const [kw, setKw] = useState(200)
  const [costoKw, setCostoKw] = useState(200)
  const [ensambladora, setEnsambladora] = useState('')
  const [sede, setSede] = useState('')
  const [proceso, setProceso] = useState('')
  const [contrato, setContrato] = useState('')
  const [autoconsumo, setAutoconsumo] = useState(false)
  const [permisos, setPermisos] = useState(0)

  const [tiposList, setTiposList] = useState([])
  const [contratosList, setContratosList] = useState([])
  const [sedesList, setSedesList] = useState([])
  const [isLoading, setIsLoading] = useState(false)


  const columns = [
    {
      title: 'Empresa',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresa = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        return empresa ? empresa.nombre : 'Desconocida'
      },
    },
    {
      title: 'Sede',
      field: 'ensambladora_id',
      render: (rowData) => {
        const empresa = empresasList.find(
          (emp) => emp.id === rowData.ensambladora_id,
        )
        if(empresa && empresa.sedes && empresa.sedes.length > 0){
        const sedeT = empresa.sedes.find((sedeTT) =>parseInt(sedeTT.id, 10) === parseInt(rowData.sede_id, 10))
        return sedeT ? sedeT.nombre  : 'Desconocida'
        }
          return 'Desconocida s'
        
      },
    },
    { title: 'Fecha Inicial', field: 'fecha_inicial', type: 'date' },
    { title: 'Fecha Final', field: 'fecha_final', type: 'date' },
    { title: 'Tipo Energía', field: 'tipo_id' },
    { title: 'KW', field: 'kw', type: 'numeric' },
    { title: 'Costo/Kw', field: 'costo_kw', type: 'numeric' },
    { title: 'Autoconsumo', field: 'autoconsumo', type: 'boolean' },
    {
      title: 'Acción',
      field: 'accion',
      render: (rowData) => (
        <IconButton onClick={() => handleDeleteEnergia(rowData.id)}>
          <DeleteIcon />
        </IconButton>
      ),
    },
  ]

  function formatearFecha(date) {
    if (!date) return null
    const fechaFormat = new Date(date)
    const año = fechaFormat.getFullYear()
    const mes = (fechaFormat.getMonth() + 1).toString().padStart(2, '0')
    const dia = fechaFormat.getDate().toString().padStart(2, '0')
    return `${año}-${mes}-${dia}`
  }

  const handleAdd = async () => {
    setIsLoading(true)
    const response = await postEnergia({
      ensambladora_id: parseInt(ensambladora, 10),
      sede_id: parseInt(sede, 10),
      fecha_inicial: formatearFecha(fechaInicial),
      fecha_final: formatearFecha(fechaFinal),
      tipo_id: parseInt(tipos, 10),
      kw,
      costo_kw: costoKw,
      autoconsumo: autoconsumo ? 1 : 0,
      proceso_id: 0,
      contrato_id: parseInt(contrato, 10),
    })

    if (response) {
      handleGetEnergias()
      resetForm()
    }
    setIsLoading(false)

  }

  const resetForm = () => {
    setTipos('')
    setFechaInicial(null)
    setFechaFinal(null)
    setKw(200)
    setCostoKw(200)
    setEnsambladora('')
    setSede('')
    setProceso('')
    setContrato('')
    setAutoconsumo(false)
  }

  const handleGetEnergias = async () => {
    const response = await getEnergias()
    if (response) {
      setData(response.energia)
    }
  }

  const handleGetEmpresas = async () => {
    const { ensambladoras } = await getEnsambladoras()
    if (ensambladoras) {
      setEmpresasList(ensambladoras)
    }
  }

  const handleDeleteEnergia = async (id) => {
    setIsLoading(true)
    const response = await deleteEnergia(id)
    if (response) {
      handleGetEnergias()
    }
    setIsLoading(false)
  }

  const handleGetTipos = async () => {
    const response = await getTipos()
    setTiposList(response.tipos.filter((item) => item.tipo_id === '4'))
    setContratosList(response.tipos.filter((item) => item.tipo_id === '6'))
    if (response) {
      console.log(response)
    }
  }

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const energiaPermiso = response.permisos.find(
        (permiso) => permiso.nombre === 'Energia',
      )
      if (energiaPermiso) {
        setPermisos(parseInt(energiaPermiso.alcance, 10))
      }
    }
  }

  const handleEmpresaChange = (e) => {
    const selectedEmpresaId = e.target.value
    setEnsambladora(selectedEmpresaId)

    const selectedEmpresa = empresasList.find(
      (empresa) => empresa.id === selectedEmpresaId,
    )
    if (selectedEmpresa && selectedEmpresa.sedes) {
      setSedesList(selectedEmpresa.sedes)
    } else {
      setSedesList([])
    }

    setSede('')
  }

  useEffect(() => {
    handleGetEnergias()
    handleGetEmpresas()
    handleGetTipos()
    handleGetPermisosByUser()
  }, [])

  return (
    <div>
       {permisos === 0 && <p>No tienes permisos para ver esta sección</p>}
      {permisos > 0 && (
        <div className={` ${isLoading ? 'my-loading' : ''}`}>
        <MaterialTable
          title="Energía"
          columns={columns}
          data={data}
          options={{
            headerStyle: {
              backgroundColor: '#f1f1f1',
              color: 'black',
              fontWeight: 'bold',
            },
          }}
        />
        </div>
      )}
      {permisos > 1 && (
        <div className={`container_baterias_form ${isLoading ? 'my-loading' : ''}`} >
          <h3>Registro Energía</h3>
          <Grid
            container
            spacing={2}
            style={{ marginTop: '40px', width: '800px' }}
          >
            <Grid item xs={6}>
              <Select
                value={tipos}
                onChange={(e) => setTipos(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Tipos de Energía
                </MenuItem>
                {tiposList &&
                  tiposList.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={autoconsumo}
                    onChange={(e) => setAutoconsumo(e.target.checked)}
                  />
                }
                label="Autoconsumo"
              />
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaInicial"
                  label="Fecha Inicial"
                  format="dd/MM/yyyy"
                  value={fechaInicial}
                  onChange={setFechaInicial}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="fechaFinal"
                  label="Fecha Final"
                  format="dd/MM/yyyy"
                  value={fechaFinal}
                  onChange={setFechaFinal}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  fullWidth
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="KW"
                type="number"
                value={kw}
                onChange={(e) => setKw(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="COSTO KW"
                type="number"
                value={costoKw}
                onChange={(e) => setCostoKw(e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <Select
                value={ensambladora}
                onChange={handleEmpresaChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Ensambladora
                </MenuItem>
                {empresasList &&
                  empresasList.map((empresa) => (
                    <MenuItem key={empresa.id} value={empresa.id}>
                      {empresa.nombre}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <Select
                value={sede}
                onChange={(e) => setSede(e.target.value)}
                displayEmpty
                fullWidth
                disabled={!ensambladora}
              >
                <MenuItem value="" disabled>
                  Sede
                </MenuItem>
                {sedesList.map((sede) => (
                  <MenuItem key={sede.id} value={sede.id.toString()}>
                    {sede.nombre}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {/* <Grid item xs={6}>
              <Select
                value={proceso}
                onChange={(e) => setProceso(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Proceso
                </MenuItem>
                <MenuItem value="1">Proceso 1</MenuItem>
                <MenuItem value="2">Proceso 2</MenuItem>
              </Select>
            </Grid> */}
            <Grid item xs={6}>
              <Select
                value={contrato}
                onChange={(e) => setContrato(e.target.value)}
                displayEmpty
                fullWidth
              >
                <MenuItem value="" disabled>
                  Contrato
                </MenuItem>
                {contratosList &&
                  contratosList.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAdd}
                style={{ width: '200px' }}
                disabled={
                  !tipos ||
                  !fechaInicial ||
                  !fechaFinal ||
                  !kw ||
                  !costoKw ||
                  !ensambladora ||
                  !sede ||
                  // !proceso ||
                  !contrato
                }
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  )
}

export default SostenibilidadEnergiaContainer
